var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecognition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9383 40.7302C20.232 39.5114 24.7695 39.5114 29.0633 40.7302M15.5633 33.3052V31.1302C11.2508 28.5239 7.70703 23.4427 7.70703 18.0427C7.70703 8.76144 16.2383 1.48644 25.8758 3.58644C30.1133 4.52394 33.8258 7.33644 35.757 11.2177C39.6758 19.0927 35.5508 27.4552 29.4945 31.1114V33.2864C29.4945 33.8302 29.7008 35.0864 27.6945 35.0864H17.3633C15.3008 35.1052 15.5633 34.2989 15.5633 33.3052Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognition);
export default __webpack_public_path__ + "static/media/recognition.491326765c7ffddcfceb7dd689f4bd88.svg";
export { ForwardRef as ReactComponent };